export const generateOrgId = (id: string | number): string => {
  const strId = String(id);
  return strId.startsWith('org_') ? strId : `org_${strId}`;
};

export const generateUserId = (id: string | number): string => {
  const strId = String(id);
  return strId.startsWith('user_') ? strId : `user_${strId}`;
};
